export default "__VITE_ASSET__Dh5P0iKi__"